import React from 'react'
import './button.scss'

type BaseProps = {
  type?: 'button' | 'reset' | 'submit'
  variant?: 'primary' | 'secondary'
  isLoading?: boolean
  name?: string
  handleClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  ariaLabelledBy?: string
  className?: string
  removeDefaultCss?: boolean
  buttonWithText?: boolean
}

type IconOnlyButton = BaseProps & {
  ButtonIcon: React.ReactElement
  label?: never
  Child?: never
  ariaLabel: string // required
}

type TextOrChildButton = BaseProps & {
  ButtonIcon?: React.ReactElement
  label?: string
  Child?: React.ReactNode
  ariaLabel?: string // optional
}

export type IButton = IconOnlyButton | TextOrChildButton

export const Button: React.FC<IButton> = ({
  type = 'button',
  isLoading = false,
  name = '',
  label,
  ButtonIcon,
  Child,
  handleClick,
  disabled = false,
  className = '',
  variant = 'primary',
  ariaLabel = `${label} button`,
  ariaLabelledBy,
  removeDefaultCss = false,
  buttonWithText = false,
}) => {
  const btnClass = removeDefaultCss
    ? ''
    : buttonWithText
      ? `text-button ${className} ${disabled ? 'disabled' : ''}`
      : `button ${ButtonIcon ? 'button--secondary' : `button--${variant}`}  ${disabled ? `disabled--${variant}` : ''} ${className}`

  return (
    <button
      type={type}
      className={btnClass}
      value={label}
      name={name}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-disabled={disabled}
      aria-busy={isLoading} //For async buttons (e.g., loading state)
    >
      {Child}
      {ButtonIcon ? ButtonIcon : null}
      {label ? <p>{label}</p> : null}
    </button>
  )
}
